export enum PAGE_TYPE {
  CONFIGURE,
  STOCK,
}
